import type { roleMatrixResource } from '@porotutu/api/features/adm/users/resource'
import { unwrap } from '@porotutu/react/api'
import { queryOptions } from '@tanstack/react-query'
import { adm } from '@/api/client'
import { ROLES } from '@/api/keys'

export type RoleMatrix = ReturnType<typeof roleMatrixResource>

export type RoleBoard = RoleMatrix['realms'][number]

export type RoleColumn = RoleBoard['roles'][number]

export type RoleRow = RoleBoard['rows'][number]

export const roleMatrixQuery = queryOptions({
  queryKey: [...ROLES, 'matrix'] as const,
  queryFn: async () => unwrap(await adm.users.roles.get()),
  staleTime: 30_000,
})
